import React from "react";
import PropTypes from "prop-types";
import New from "../../../../assets/icons/new-orange.svg";
import useWindowDimensions from "../../../../hook/useWindowDimension";
import NouvelleQuestion from "../../../../assets/img/offerModal/offre-3.png";
import {useHistory} from "react-router-dom";

const ContactCareManager = ({
                                setOpenFreeQuestionChatBot
                            }) => {
    const history = useHistory();
    const {width} = useWindowDimensions();
    const handlePlanDemand = () => {
        if (width > 599) history.push("/free-question");
        else setOpenFreeQuestionChatBot(true);
    };
    return (
        <li className={"contactManager"} id={"contactManagerQuestions"} onClick={handlePlanDemand}>
            {width > 599
                ? <div><img src={New} alt="continuer"/>
                    <p>Contacter un Care Manager</p></div>
                : <div id={"nouvelleQuestion-mobile"}>
                    <div id={"bck-img"} style={{backgroundImage: `url(${NouvelleQuestion})`}}></div>
                    <p>{"J'ai une nouvelle question ?"}</p>
                </div>
            }
        </li>);
};

ContactCareManager.propTypes = {
    setOpenFreeQuestionChatBot: PropTypes.func
};

export default ContactCareManager;